import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { useDeleteUserMutation } from '../../hooks/api';

interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  onSuccess: (deletedUsername: string) => void;
  onError: (message: string) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  username: string | null;
}

const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  open,
  onClose,
  onSuccess,
  onError,
  loading,
  setLoading,
  username,
}) => {
  const deleteUserMutation = useDeleteUserMutation();

  const handleDeleteUser = async () => {
    if (!username) return;

    try {
      setLoading(true);
      await deleteUserMutation.mutateAsync(username);
      onSuccess(username);
      onClose();
    } catch (err) {
      console.error(`Error deleting user:`, err);
      onError(`Failed to delete user. Please try again.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Delete User</DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to delete user <strong>{username}</strong>? This action cannot be
          undone.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleDeleteUser} variant="contained" color="error" disabled={loading}>
          {loading ? 'Deleting...' : 'Delete User'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteUserDialog;
